export default {
    inserted: function (el) {
        el.focus()
    }
}


// WEBPACK FOOTER //
// ./src/_eng/directives/focus.js